import { GET_FACEBOOK_PAGE_ANALYTICS_SUCCESS, GET_FACEBOOK_PAGE_ANALYTICS_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { pages: [], errors: null };

export default function facebookPagesAnalytics(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case GET_FACEBOOK_PAGE_ANALYTICS_SUCCESS:
      return { ...state, pages: action.payload.data, errors: null }
    case GET_FACEBOOK_PAGE_ANALYTICS_FAILURE:
      return { ...state, pages: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
